import { parse } from "date-fns";

export const parseDate = (dateString: string, formatString: string, referenceDate?: Date): Date | null => {
    if (!referenceDate) referenceDate = new Date();

    try {
        return parse(dateString, formatString, referenceDate);
    } catch (e) {
        console.error(`Could not parse date '${dateString}' with format ${formatString}: ${e.message}`, e);
        return null;
    }
};
